module.exports = __webpack_public_path__ + "img/interest.212e4acf.png";